var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"translation-tool-text-display"},[_vm._l((_vm.textSegments),function(segment,index){return [(!_vm.getTooltip(segment))?_c('span',{key:index,class:{
        'clickable-term': segment.isClickable,
        'ignored-term': segment.isIgnored
      },on:{"click":function($event){return _vm.handleSegmentClick(segment)}}},[_vm._v(_vm._s(segment.text))]):_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.getTooltip(segment)),expression:"getTooltip(segment)"}],key:'no-tooltip-'+index,class:{
        'clickable-term': segment.isClickable,
        'ignored-term': segment.isIgnored
      },on:{"click":function($event){return _vm.handleSegmentClick(segment)}}},[_vm._v(_vm._s(segment.text))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }